import {FC} from "react";
import {getLabelName} from "../../utils";

export const UnAuthorizedPage: FC = () => {
    return (
        <>
            {/* we need to add page with image */}
            <p>{getLabelName("Un Authorized request please re-login again or you don't have\n" +
                "        permissions to access page")}
            </p>
        </>
    );
};
